module.exports = ['$scope', '$location', 'StaffEFTRequests',
  function ($scope, $location, StaffEFTRequests) {
    $scope.filters = {};

    const loadEFTRequests = () => {
      $scope.filters.category = $location.search().category;
      $scope.filters.category = $location.search().category;
      $scope.filters.dateRequested = $location.search().dateRequested;
      $scope.filters.client = $location.search().client ? $location.search().client : '';
      $scope.filters.frequency = $location.search().frequency;
      $scope.filters.status = $location.search().status;
      $scope.filters.requestedFor = $location.search().requestedFor;
      $scope.filters.custodian = $location.search().custodian;
      $scope.filters.amount = {
        from: $location.search().amountFrom,
        to: $location.search().amountTo,
      };
      if ($location.search().orderBy) {
        $scope.orderBy = $location.search().orderBy;
      }
      if ($location.search().reverse) {
        $scope.reverse = $location.search().reverse;
      }

      $scope.page = $location.search().page ? $location.search().page : 1;
      $scope.limit = $location.search().limit ? $location.search().limit : 10;
      $scope.search = $location.search().search ? $location.search().search : '';

      StaffEFTRequests.get({
        filters: $scope.filters,
        page: $scope.page,
        limit: $scope.limit,
        orderBy: $scope.orderBy,
        reverse: $scope.reverse,
        search: $scope.search,
      }).$promise.then((eftRequests) => {
        $scope.eftRequests = eftRequests;
      });
    };

    loadEFTRequests();

    $scope.$on('$routeUpdate', () => loadEFTRequests());
    $scope.$on('refreshTransfersList', () => loadEFTRequests());

    return $scope;
  }
];
